import Breadcrumbs from 'components/Common/Breadcrumb'
import Loader from 'components/Common/Loader'
import { USER_ROLE_BOSS, USER_ROLE_MANAGER } from 'constants/userRoles'
import ManagerInfo from 'pages/ControlPanel/Components/ManagerInfo'
import MonthlyInfo from 'pages/ControlPanel/Components/MonthlyInfo'
import Notifications from 'pages/ControlPanel/Components/Notifications/Notifications'
import StaticsInfo from 'pages/ControlPanel/Components/StaticsInfo'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { MetaTags } from 'react-meta-tags'
import { connect } from 'react-redux'
import { getManagerDetailById, getManagerList } from 'store/actions'



export const Inbox = ({ t, isLoadingUsers, isLoadingOffers, isLoadingOrders, getManagerList, getManagerDetailById, isLoadingManagers }) => {

	const [selectedManagersIds, setSelectedManagers] = useState([])

	const handleManagerSelection = (selectedIds) => {
		setSelectedManagers(selectedIds)
	}



	const getUserName = () => {
		if (localStorage.getItem('authUser')) {
			const obj = JSON.parse(localStorage.getItem('authUser'))
			return obj
		}
	}

	useEffect(() => {
		const userData = getUserName()
		if (userData.roles.includes(USER_ROLE_BOSS)) {
			getManagerList()
		} else if (userData.roles.includes(USER_ROLE_MANAGER)) {
			getManagerDetailById(userData.id)
			setSelectedManagers([userData.id])
		}
		//TODO ADD ERROR NO MANAGER
	}, [])



	const isLoading = (isLoadingUsers || isLoadingOffers || isLoadingOrders || isLoadingManagers) && false

	return (
		<div className='page-content marginFooter'>
			<MetaTags>
				<title>Proto&Go! | {t('inbox', { ns: 'naming' })}</title>
			</MetaTags>
			<Breadcrumbs
				title={t('homepage', { ns: 'naming' })}
				breadcrumbItems={
					[{
						item: t('inbox', { ns: 'naming' }),
						link: '/inbox',
					}]
				}
			/>
			<div className="container-fluid h-100">
				{
					isLoading ? <Loader /> :
						<div className="row">
							<div className="col-4">
								<div className=" p-4 mb-2 bg-white">
									<ManagerInfo onManagerSelection={handleManagerSelection} />
								</div>
								<div className=" p-3 bg-white">
									<MonthlyInfo selectedManagersIds={selectedManagersIds} />
								</div>
								<div className='col mb-2'>
									<StaticsInfo selectedManagersIds={selectedManagersIds} />
								</div>
							</div>
							<div className="col me-2">
								<div className=" p-4 bg-white" style={{ minHeight: "99%" }}>
									<Notifications selectedManagersIds={selectedManagersIds} />
								</div>

							</div>
						</div>
				}
			</div>
		</div>
	)
}

Inbox.propTypes = {
	t: PropTypes.func,
	isLoadingUsers: PropTypes.bool,
	isLoadingOrders: PropTypes.bool,
	isLoadingOffers: PropTypes.bool,
	getManagerDetailById: PropTypes.func,
	getManagerList: PropTypes.func,
	isLoadingManagers: PropTypes.bool

}

const mapStateToProps = (state) => ({

	isLoadingUsers: state.Users.isLoading,
	isLoadingOrders: state.Orders.isLoading,
	isLoadingOffers: state.Offers.isLoading,
	isLoadingManagers: state.Users.isLoadingManagers
})

const mapDispatchToProps = {

	getManagerList,
	getManagerDetailById

}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Inbox))

